<template lang="pug">
  .cart-remove-promo-modal.text-center
    h3.upper.bold.xs-f-medium.max-at-tweak Are you sure?
    p.xs-mt-150m.xs-mb-150m.xs-f-small.max-at-tweak Are you sure you want to remove this promotion?
    button.xs-mr-150m.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak(@click="cancel") Cancel
    button.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak(@click="removePromo") Confirm

</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "CartRemovePromoModal",

    props: {
      promoId: null
    },

    methods: {
      ...mapActions('cart', ['removeCoupon']),

      cancel() {
        this.$emit('hide-modal');
      },

      removePromo() {
        this.removeCoupon({
          cartType: 'active',
          id: this.promoId
        }).then(() => {
          this.$emit('hide-modal');
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .cart-remove-promo-modal
    padding-top 1.5em
    padding-bottom 2.5em
    
    .mr-btn
      display inline-block
      vertical-align top
      width 14em
      
    @media mq-mobile
      .mr-btn
        width 9.5em
  
</style>
